"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.convertToOptions = exports.SEGMENT = exports.CARD_THEME = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUnifiedicons = _interopRequireDefault(require("@bit/gerenciatd.unifiedicons.svg-icon-loader"));

require("./HoverEffectCard.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const SEGMENT = {
  GP: 'gp',
  EMP: 'emp'
};
exports.SEGMENT = SEGMENT;
const CARD_THEME = {
  SHORT: 'short',
  LARGE: 'large'
};
exports.CARD_THEME = CARD_THEME;

const convertToOptions = optionsObject => {
  const keys = Object.keys(optionsObject);
  return keys.map(key => {
    return optionsObject[key];
  });
};

exports.convertToOptions = convertToOptions;

const HoverEffectCard = _ref => {
  let {
    components,
    cardTheme,
    segment
  } = _ref;

  // Compruebo si existe texto alternativo para el efecto Hover
  if (!components['TextInfo-2'] && components['TextInfo-1']) {
    components['TextInfo-2'] = components['TextInfo-1'];
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: `HoverEffectCard Size--${cardTheme}`,
    children: [components['Image-1'] && components['Image-1'].src && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "BgImage",
      style: {
        backgroundImage: `url(${components['Image-1'].src})`
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: `HoverLayout Default Default--${segment}`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "Content",
        children: [cardTheme === CARD_THEME.LARGE && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, _objectSpread(_objectSpread({}, components['SvgIconLoader-1']), {}, {
          className: "Icon"
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, components['TextInfo-1']))]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, components['CustomLink-1']), {}, {
        isBlockElement: true
      }))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: `HoverLayout Hover Hover--${segment}`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "Content",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, components['TextInfo-2']))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, components['CustomLink-1']), {}, {
        isBlockElement: true
      }))]
    })]
  });
};

HoverEffectCard.propTypes = {
  /**
   * {
   *  "info": "Define el componente para pintar una card con efecto Hover",
   *  "kind": "both",
   *  "beautifulName": "components"
   * }
   */
  components: _propTypes.default.object.isRequired,

  /**
   * {
   *  "info": "Define el estilo para pintar una card con efecto Hover",
   *  "kind": "both",
   *  "beautifulName": "card theme"
   * }
   */
  cardTheme: _propTypes.default.oneOf(convertToOptions(CARD_THEME)),

  /**
   * {
   *  "info": "Define el segmento para pintar una card con efecto Hover",
   *  "kind": "both",
   *  "beautifulName": "segmento"
   * }
   */
  segment: _propTypes.default.oneOf(convertToOptions(SEGMENT))
};
HoverEffectCard.defaultProps = {
  cardTheme: CARD_THEME.SHORT,
  segment: SEGMENT.GP
};
var _default = HoverEffectCard;
exports.default = _default;

//# sourceMappingURL=index.js.map